import gql from 'graphql-tag';

export default gql`
  fragment preleadProjectCopyFragment on PreleadProjectCopy {
    id
    status
    rowCount
    currentRowNumber
    percent
  }
`;
